import _isBefore from "date-fns/isBefore"
import _add from "date-fns/add"

import { STRICT_TIME_REGEX, TIME_FORMAT } from "../../constants/formats";
import { PickerUtils } from "./PickerUtils";



interface IGetDefaultDateValueOptions {
    defaultTime?: string;
    hourRoundingValue?: number;
    minDate?: Date;
};

export const getDefaultDateValue = (reference: Date, options: IGetDefaultDateValueOptions): string | undefined => {
    let date = PickerUtils.ensureFreshDateInstance(reference);
    if (date) {
        let time = date;
        if (options.defaultTime && RegExp(STRICT_TIME_REGEX).test(options.defaultTime)) {
            const [hour, minutes] = options.defaultTime.split(":").map(Number);
            time = PickerUtils.resetTime(date);
            time.setHours(hour);
            time.setMinutes(minutes);
        } else {
            time = PickerUtils.roundToNearestHour(time, options.hourRoundingValue);
        };

        if (options.minDate && (_isBefore(time, options.minDate) || PickerUtils.formatDate(options.minDate, TIME_FORMAT) === PickerUtils.formatDate(time, TIME_FORMAT))) {
            date = _add(date, { days: 1 }); // _add day if time is before reference
        };

        date = PickerUtils.overwriteTimePartOfDate(date, time);
        if (date) {
            return date.toISOString()
        }
    };
};

